import { ActivityType } from 'app/constants/activity'

export const getActivityType = (type) => {
  let activityType = ActivityType.UNKNOWN

  switch (type) {
    case 1:
      activityType = ActivityType.AVAILABILITY
      break
    case 2:
      activityType = ActivityType.WORK
      break
    case 3:
      activityType = ActivityType.DRIVING
      break
    case 0:
      activityType = ActivityType.REST
      break
    case 4:
      activityType = ActivityType.UNKNOWN
      break
  }

  return activityType
}

export const getActivityTypeNumber = (type: ActivityType) => {
  let activityType = 4

  switch (type) {
    case ActivityType.AVAILABILITY:
      activityType = 1
      break
    case ActivityType.WORK:
      activityType = 2
      break
    case ActivityType.DRIVING:
      activityType = 3
      break
    case ActivityType.REST:
      activityType = 0
      break
    case ActivityType.UNKNOWN:
      activityType = 4
      break
  }

  return activityType
}
